import React, { useState, useEffect } from 'react';
import { orderHistoryService } from '../services/orderHistory';

const OrderHistory = ({ onClose }) => {
  const [orderHistory, setOrderHistory] = useState([]);

  useEffect(() => {
    setOrderHistory(orderHistoryService.getHistory());
  }, []);

  const clearHistory = () => {
    if (window.confirm('Are you sure you want to clear your order history?')) {
      orderHistoryService.clearHistory();
      setOrderHistory([]);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '15px',
        padding: '30px',
        maxWidth: '500px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          paddingBottom: '15px',
          borderBottom: '2px solid #f0f0f0'
        }}>
          <h2 style={{ margin: 0, color: '#333', fontSize: '1.5rem' }}>
            Order History (24h)
          </h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        {orderHistory.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: '#666'
          }}>
            <div style={{ fontSize: '3rem', marginBottom: '15px' }}>🍽️</div>
            <p>No recent orders!</p>
            <p>Orders from the last 24 hours will appear here.</p>
          </div>
        ) : (
          <div>
            {orderHistory.map((order, index) => (
              <div key={order.id || index} style={{
                border: '1px solid #e0e0e0',
                borderRadius: '10px',
                padding: '20px',
                marginBottom: '15px',
                backgroundColor: '#fafafa'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '15px'
                }}>
                  <div>
                    <h4 style={{ margin: '0 0 5px 0', color: '#333', fontSize: '1.1rem' }}>
                      {order.restaurant.name}
                    </h4>
                    <p style={{ margin: 0, color: '#666', fontSize: '0.9rem' }}>
                      {order.date} at {order.time}
                    </p>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#28a745' }}>
                      ₹{order.totalAmount}
                    </div>
                    <div style={{ fontSize: '0.8rem', color: '#666' }}>
                      #{order.orderNumber}
                    </div>
                  </div>
                </div>

                <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: '15px' }}>
                  {order.items?.map((item, itemIndex) => (
                    <div key={itemIndex} style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '8px'
                    }}>
                      <span style={{ color: '#333' }}>
                        {item.quantity}x {item.name}
                      </span>
                      <span style={{ color: '#666' }}>
                        ₹{item.total_price}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <button
                onClick={clearHistory}
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '0.9rem'
                }}
              >
                Clear History
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderHistory;